module.exports = __webpack_public_path__ + "media/images/icon__info--white@3x-5ad38ab0225082d875732a1d56f470dd.png";